/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_TitleInputs */

const en_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Benchmarks`)
};

const de_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehalts-Benchmarks`)
};

const fr_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks salariaux`)
};

const es_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks salariales`)
};

const it_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark salariali`)
};

const nl_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarisbenchmarks`)
};

const pl_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarki wynagrodzeń`)
};

const fi_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkatasot`)
};

const da_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lønbenchmarks`)
};

const sv_salary_search_title = /** @type {(inputs: Salary_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lönebenchmarks`)
};

/**
* | output |
* | --- |
* | "Salary Benchmarks" |
*
* @param {Salary_Search_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_title = /** @type {((inputs?: Salary_Search_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_title(inputs)
	if (locale === "fr") return fr_salary_search_title(inputs)
	if (locale === "es") return es_salary_search_title(inputs)
	if (locale === "it") return it_salary_search_title(inputs)
	if (locale === "nl") return nl_salary_search_title(inputs)
	if (locale === "pl") return pl_salary_search_title(inputs)
	if (locale === "fi") return fi_salary_search_title(inputs)
	if (locale === "da") return da_salary_search_title(inputs)
	if (locale === "sv") return sv_salary_search_title(inputs)
	return en_salary_search_title(inputs)
});